import "../../../../../styles/global.css";
import { icons } from "../../../../../constants";
import React, { useState } from "react";

const monthNames = [
  "Januar",
  "Februar",
  "Mart",
  "April",
  "Maj",
  "Jun",
  "Jul",
  "Avgust",
  "Septembar",
  "Oktobar",
  "Novembar",
  "Decembar",
];

const DateTimeNavigation = ({
  currentYear,
  setCurrentYear,
  currentMonth,
  setCurrentMonth,
  selectedDate,
}) => {
  const goToPreviousMonth = () => {
    setCurrentMonth((prevMonth) => {
      if (prevMonth === 0) {
        setCurrentYear((y) => y - 1);
        return 11;
      }
      return prevMonth - 1;
    });
  };

  const goToNextMonth = () => {
    setCurrentMonth((prevMonth) => {
      if (prevMonth === 11) {
        setCurrentYear((y) => y + 1);
        return 0;
      }
      return prevMonth + 1;
    });
  };
  const [theme, setTheme] = useState(
    () => localStorage.getItem("theme") || "light"
  );

  return (
    <div className="flex-direction-row gap-12 justify-between items-center date-time-navigation">
      {/* Year Navigation */}
      <div className="flex-direction-row items-center gap-8 font-16 justify-between inria-sans-400 date-time-navigation-year-wrapper">
        <button
          onClick={() => setCurrentYear((y) => y - 1)}
          className="flex-direction-row items-center justify-center date-time-navigation-btn"
        >
          <img
            src={theme === "light" ? icons.arrow_down : icons.arrow_down_dark}
            alt="prev-year"
            width={24}
            height={24}
            className="pointer"
            style={{ transform: "rotate(90deg)" }}
          />
        </button>
        <p className="font-semibold">{currentYear}</p>
        <button
          onClick={() => setCurrentYear((y) => y + 1)}
          className="flex-direction-row items-center justify-center date-time-navigation-btn"
        >
          <img
            src={theme === "light" ? icons.arrow_down : icons.arrow_down_dark}
            alt="next-year"
            width={24}
            height={24}
            className="pointer"
            style={{ transform: "rotate(-90deg)" }}
          />
        </button>
      </div>

      {/* Month Navigation */}
      <div className="flex-direction-row items-center gap-8 justify-between inria-sans-400 date-time-navigation-month-wrapper">
        <button
          onClick={goToPreviousMonth}
          className="flex-direction-row items-center justify-center date-time-navigation-btn"
        >
          <img
            src={theme === "light" ? icons.arrow_down : icons.arrow_down_dark}
            alt="prev-month"
            width={24}
            height={24}
            className="pointer"
            style={{ transform: "rotate(90deg)" }}
          />
        </button>
        <p className="font-semibold">{monthNames[currentMonth]}</p>
        <button
          onClick={goToNextMonth}
          className="flex-direction-row items-center justify-center date-time-navigation-btn"
        >
          <img
            src={theme === "light" ? icons.arrow_down : icons.arrow_down_dark}
            alt="next-month"
            width={24}
            height={24}
            className="pointer"
            style={{ transform: "rotate(-90deg)" }}
          />
        </button>
      </div>
    </div>
  );
};

export default DateTimeNavigation;
